import FiveByTen from '../../assets/5x10.png'
import TenByTen from '../../assets/10x10.png'
import TenByFifteen from '../../assets/10x15.png'
import TwelveByThirtyFive from '../../assets/12x35.png'
import { UnitMaster } from './reducer'

export const getImage = (size: string) => {
  if (size === '5x10') return FiveByTen
  if (size === '10x10') return TenByTen
  if (size === '10x15') return TenByFifteen

  return TwelveByThirtyFive
}

export const getUnitTags = ({
  isClimate,
  isCovered,
}: Pick<UnitMaster, 'isClimate' | 'isCovered'>) => {
  const tags = ['Ground-level access']

  if (isClimate) tags.unshift('Climate controlled')
  if (isCovered) tags.unshift('Covered parking')

  return tags
}

export const getAvailableCount = (
  unit: Pick<UnitMaster, 'quantity' | 'occupied'>
) => unit.quantity - unit.occupied
